import React from 'react';

const PrivacyPolicy: React.FC = () => {
    return (
        <article className='aboutus'>
            <h1>隱私權政策</h1>
            <p>「Lmgoal」（以下簡稱「我們」或者「易迪軟體有限公司」）深知個人資訊對您的重要性，並會盡力保護您的個人資訊安全可靠，我們致力於維持您對我們的信任，恪守以下原則，保護您的個人資訊：權責一致原則、目的明確原則、選擇同意原則、最少夠用原則、確保安全原則、主體參與原則、公開透明原則等等。同時我們承諾，我們將按業界成熟的安全解決方案，採取相應的安全保護措施來保護您的個人資訊。鑑此，我們制定本《易迪軟體有限公司隱私權政策》（下稱「本政策／本隱私權政策」）並提醒您：</p>
            <p>本政策適用於易迪軟體有限公司產品或服務。若我們關聯公司的產品或服務中使用了易迪軟體有限公司提供的產品或服務（例如直接使用易迪軟體有限公司帳號登入）但未設獨立隱私權政策，則本政策同樣適用於該部分產品或服務。</p>
            <p>需要特別說明的是，本政策不適用於其他第三方向您提供的服務，也不適用於易迪軟體有限公司中已另行獨立設置隱私權政策的產品或服務。</p>
            <p>在使用易迪軟體有限公司各項產品或服務前，請您務必仔細閱讀並透徹理解本政策，在確認充分理解並同意後使用相關產品或服務。一旦您開始使用易迪軟體有限公司各項產品或服務，即表示您已充分理解並同意本政策。如對本政策內容有任何疑問、意見或建議，您可透過易迪軟體有限公司提供的各種聯絡方式與我們聯繫。</p>
            <p>本隱私權政策部分將協助您了解以下內容：</p>
            <ul>
                <li>1、我們如何收集和使用您的個人資訊</li>
                <li>2、我們如何使用 Cookie 和同類技術</li>
                <li>3、我們如何共享、轉讓、公開披露您的個人資訊</li>
                <li>4、我們如何保護您的個人資訊</li>
                <li>5、您如何管理您的個人資訊</li>
                <li>6、我們如何處理未成年人的個人資訊</li>
                <li>7、您的個人資訊如何在全球範圍轉移</li>
                <li>8、我們集成的第三方 SDK</li>
                <li>9、本隱私權政策如何更新</li>
                <li>10、如何聯絡我們</li>
            </ul>
            <h3>一、我們如何收集和使用您的個人資訊</h3>
            <p>個人資訊是指以電子或其他方式記錄的能夠單獨或與其他資訊結合識別特定自然人身份或反映特定自然人活動情形的各種資訊，我們會出於本政策所述的以下目的，收集和使用您的個人資訊：</p>
            <p>（一）幫助您成為我們的用戶</p>
            <p>為完成創建帳號，以便我們為您提供服務，您需要提供以下資訊：您的暱稱、頭像、性別、出生年月日、手機號碼/facebook account/google account/apple id／微信號／QQ號，並創建用戶名和密碼。</p>
            <p>在註冊過程中，如果您提供以下額外資訊補全個人資料，將有助於我們給您提供更好的服務和體驗：您的真實姓名、真實證件資訊、家鄉、情感狀態、星座、職業、學校、您本人的真實頭像。但若您不提供這些資訊，將不影響使用易迪軟體有限公司產品或服務的基本功能。</p>
            <p>您提供的上述資訊將在您使用本服務期間持續授權我們使用。在您主動註銷帳號時，我們將依據適用法律法規的要求，盡快將其匿名或刪除您的個人資訊。</p>
            <p>（二）為您展示和推送商品或服務</p>
            <p>為改善我們的產品或服務、向您提供個性化的資訊搜尋及交易服務，我們會根據您的瀏覽及搜尋記錄、設備資訊、位置資訊、交易資訊，提取您的瀏覽、搜尋偏好、行為習慣、位置資訊等特徵，基於特徵標籤進行間接人群描繪並展示、推送資訊。</p>
            <p>若您不希望接受我們向您發送的商業廣告，您可隨時透過相應產品退訂功能取消。</p>
            <p>（三）向您提供商品或服務</p>
            <ul>
                <li>1、您向我們提供的資訊
                    <p>您在註冊帳戶或使用我們的服務時，向我們提供的相關個人資訊，例如電話號碼、電子郵件、銀行卡號或支付寶帳號等；</p>
                    <p>您透過我們的服務向其他方提供的共享資訊，以及您使用我們的服務時所儲存的資訊。在向易迪軟體有限公司提供該其他方的前述個人資訊之前，您需確保已取得其授權同意。</p>
                </li>
                <li>2、我們在您使用服務過程中收集的資訊
                    <p>為向您提供更契合您需求的頁面展示和搜尋結果、了解產品適配性、識別帳號異常狀態，我們會收集關於您使用服務及使用方式的資訊，並將這些資訊進行關聯，這些資訊包括：</p>
                    <p>設備資訊：我們會根據您在軟體安裝及使用中授予的具體權限，接收並記錄您所使用設備相關資訊（例如設備型號、作業系統版本、設備設定、唯一設備識別碼等軟硬體特徵資訊）、設備所在位置相關資訊（例如 IP 地址、位置資訊以及能夠提供相關資訊的 Wi-Fi 接入點、藍牙和基站等傳感器資訊。因我們提供的服務係基於地理位置提供的移動社交服務，您確認成功註冊「易迪軟體有限公司」帳號視為確認授權我們提取、公開及使用您的地理位置資訊。若您需要終止向其他用戶公開其地理位置資訊，可隨時自行設定為隱身狀態）。</p>
                    <p>日誌資訊：當您使用我們的網站或客戶端提供的產品或服務時，我們會自動收集您對我們服務的詳細使用情形，作為有關網路日誌保存。例如您的搜尋查詢內容、IP 地址、瀏覽器類型、電信業者、使用的語言、訪問日期和時間及您訪問的網頁記錄等。</p>
                    <p>請注意，單獨的設備資訊、日誌資訊等是無法識別特定自然人身份的資訊。若我們將此類非個人資訊與其他資訊結合用於識別特定自然人身份，或者將其與個人資訊結合使用，則在結合使用期間，此類非個人資訊將被視為個人資訊，除非取得您的授權或法律法規另有規定，我們會將該類個人資訊進行匿名化、去標識化處理。</p>
                    <p>當您與我們聯繫時，我們可能會保存您的通信／通話記錄和內容或您留下的聯絡方式等資訊，以便與您聯繫或協助您解決問題，或記錄相關問題的處理方案及結果。</p>
                    <p>MAC 地址：應用運行時會獲取用戶的【MAC 地址】等敏感資訊，旨在防止多個不同手機號碼透過相同手機設備進行註冊。</p>
                </li>
                <li>3、我們通過間接獲得方式收集到的您的個人資訊
                    <p>您可透過易迪軟體有限公司帳號在我們提供的連結入口使用我們關聯公司提供的產品或服務，為便於我們基於關聯帳號共同向您提供一站式服務並便於您統一進行管理，我們會在易迪軟體有限公司集中展示您的資訊或推薦您可能感興趣的資訊，包括來自直播、遊戲的資訊。您可透過易迪軟體有限公司首頁、「更多」等功能發現、使用上述服務。</p>
                    <p>當您透過我們的產品或服務使用上述服務時，您授權我們根據實際業務及合作需要，從我們關聯公司處接收、彙總、分析經我們確認其來源合法或您授權同意其向我們提供的您的個人資訊或交易資訊。</p>
                    <p>若您拒絕提供上述資訊或拒絕授權，可能無法使用我們關聯公司的相應產品或服務，或者無法展示相關資訊，但不影響使用易迪軟體有限公司瀏覽、聊天、發表動態等核心服務。</p>
                </li>
            </ul>
            <p>（四）為您提供安全保障</p>
            <p>請注意，為確保用戶身份真實性、向您提供更好的安全保障，您可向我們提供身份證、軍官證、護照、駕駛證、社保卡、居住證等身份資訊、面部特徵等生物識別資訊、芝麻信用等個人敏感資訊以完成實名認證。若您拒絕提供上述資訊，可能無法使用帳戶管理、開通直播、進行可能存在風險的交易等服務，但不影響您使用瀏覽、聊天等服務。</p>
            <p>為提高您使用我們及我們關聯公司、合作夥伴提供服務的安全性，保護您或其他用戶或公眾的人身財產安全免遭侵害，更好地預防釣魚網站、詐騙、網路漏洞、電腦病毒、網路攻擊、網路入侵等安全風險，更準確地識別違反法律法規或<b>易迪軟體有限公司</b>相關協議規則的情形，我們可能使用或整合您的用戶資訊、交易資訊、設備資訊、有關網路日誌以及我們關聯公司、合作夥伴依據法律或經您授權共享的資訊，來綜合判斷您帳戶及交易風險、進行身份驗證、檢測及防範安全事件，並依法採取必要的記錄、稽核、分析、處置措施。</p>
            <p>（五）其他用途</p>
            <p>我們將資訊用於本政策未載明的其他用途，或者將基於特定目的收集而來的資訊用於其他目的時，會事先徵求您的同意。</p>
            <p>（六）徵得授權同意的例外</p>
            <p>根據相關法律法規規定，下列情形中收集您的個人資訊無需徵得您的授權同意：</p>
            <ul>
                <li>1、與國家安全、國防安全有關的；</li>
                <li>2、與公共安全、公共衛生、重大公共利益有關的；</li>
                <li>3、與犯罪偵查、起訴、審判和判決執行等有關的；</li>
                <li>4、出於維護個人資訊主體或其他個人之生命、財產等重大合法權益但又很難取得您本人同意的；</li>
                <li>5、所收集的個人資訊為您自行向社會公眾公開的；</li>
                <li>6、從合法公開披露的資訊中收集個人資訊的，如合法的新聞報導、政府資訊公開等渠道；</li>
                <li>7、依據您的要求簽訂合同所必需的；</li>
                <li>8、用於維護所提供的產品或服務的安全穩定運行所必需的，例如發現、處置產品或服務故障；</li>
                <li>9、為合法的新聞報導所必需的；</li>
                <li>10、學術研究機構基於公共利益開展統計或學術研究所必需，且對外提供學術研究或描述的結果時，對結果中所包含的個人資訊進行去標識化處理的；</li>
                <li>11、法律法規規定的其他情形。</li>
            </ul>
            <p>若我們停止運營<b>易迪軟體有限公司</b>產品或服務，我們將及時停止繼續收集您個人資訊的活動，並以逐一送達或公告的形式通知您，同時對所持有的個人資訊進行刪除或匿名化處理。</p>
            <h3>二、我們如何使用 Cookie 和同類技術</h3>
            <p>（一）Cookie</p>
            <p>為確保網站正常運轉、為您獲得更輕鬆的訪問體驗、向您推薦您可能感興趣的內容，我們會在您的計算機或移動設備上存儲名為 Cookie 的小型資料檔案。Cookie 通常包含識別碼、站點名稱以及一些數字與字元。藉由 Cookie，網站能夠存儲您的偏好等資料。</p>
            <p>（二）網站信標和像素標籤</p>
            <p>除 Cookie 外，我們還會在網站上使用網站信標和像素標籤等其他同類技術。例如，我們向您發送的電子郵件可能含有連結至我們網站內容的網址，若您點擊該連結，我們則會追蹤此次點擊，幫助我們了解您對產品或服務的偏好，以便主動改善客戶服務體驗。網站信標通常是一種嵌入到網站或電子郵件中的透明圖像。藉由電子郵件中的像素標籤，我們能夠得知電子郵件是否被打開。若您不希望自己的活動以此方式被追蹤，則可隨時從我們的寄信名單中退訂。</p>
            <h3>三、我們如何共享、轉讓、公開披露您的個人資訊</h3>
            <p>（一）共享</p>
            <p>除下列情形外，我們不會與<b>易迪軟體有限公司</b>服務提供者以外的公司、組織及個人共享您的個人資訊：</p>
            <ul>
                <li>1、在獲取明確同意的情況下共享：獲得您的明確同意後，我們會與其他方共享您的個人資訊。</li>
                <li>2、在法定情形下的共享：我們可能根據法律法規規定、訴訟爭議解決需要，或依行政、司法機關依法提出的要求，對外共享您的個人資訊。</li>
                <li>3、與關聯公司間共享：為便於我們基於關聯帳號共同向您提供服務、推薦您可能感興趣的資訊，或保護<b>易迪軟體有限公司</b>關聯公司或其他用戶及公眾的人身財產安全免遭侵害，您的個人資訊可能會與我們的關聯公司共享。我們僅會共享必要的個人資訊（例如，為便於您使用<b>易迪軟體有限公司</b>帳號使用我們關聯公司產品或服務，我們會向關聯公司共享您必要的帳號資訊），若我們共享您的個人敏感資訊或關聯公司改變個人資訊的使用及處理目的，將再次徵求您的授權同意。</li>
                <li>4、與授權合作夥伴共享：僅為實現本隱私權政策中所聲明的目的，我們的某些服務將由我們與授權合作夥伴共同提供。為提供更好的客戶服務和用戶體驗，我們可能會與合作夥伴共享您的某些個人資訊（例如安排合作夥伴提供服務）。我們僅會出於合法、正當、必要、特定、明確的目的共享您的個人資訊，且僅共享提供服務所必要的個人資訊。合作夥伴無權將共享的個人資訊用於與產品或服務無關的其他用途。</li>
            </ul>
            <p>目前，我們的授權合作夥伴包括以下類型：</p>
            <ul>
                <li>（1）廣告、分析服務類的授權合作夥伴。除非得到您的許可，否則我們不會將您的個人身份資訊（指能識別您身份的資訊，例如姓名或電子郵件，透過這些資訊可聯絡您或識別您的身份）與提供廣告、分析服務的合作夥伴共享。我們會向這些合作夥伴提供關於其廣告覆蓋面和有效性的資訊，但不提供您的個人身份資訊，或將這些資訊進行彙總，以致無法識別您的個人身份。例如，只有在廣告主同意遵守我們的廣告發布準則後，我們才可能告知廣告主其廣告的效果，或有多少人看到廣告或在觀看後安裝應用，或向這些合作夥伴提供無法識別個人身份的統計資訊（例如「男性，25-29 歲，位於台北」），以幫助其了解受眾或顧客。</li>
                <li>（2）供應商、服務提供商和其他合作夥伴。為支持我們的業務，我們會將資訊傳送給提供技術基礎設施服務、分析我們服務使用方式、衡量廣告與服務效果、提供客戶服務、支付便利或進行學術研究與調查的供應商、服務提供商和其他合作夥伴。</li>
            </ul>
            <p>對於我們與之共享個人資訊的公司、組織及個人，我們將簽訂嚴格的資料保護協定，要求其依照我們的指示、本隱私權政策及其他任何相關的保密與安全措施處理個人資訊。</p>
            <p>（二）轉讓</p>
            <p>除下列情形外，我們不會將您的個人資訊轉讓給任何公司、組織及個人：</p>
            <ul>
                <li>1、在獲取明確同意的情況下轉讓：獲得您的明確同意後，我們會向其他方轉讓您的個人資訊；</li>
                <li>2、在涉及合併、收購或破產清算情形時，或其他涉及合併、收購或破產清算情形下，如涉及到個人資訊轉讓，我們會要求新的持有您個人資訊的公司、組織繼續受本政策的約束，否則我們將要求該公司、組織或個人重新向您徵求授權同意。</li>
            </ul>
            <p>（三）公開披露</p>
            <p>我們僅會在下列情形中，公開披露您的個人資訊：</p>
            <ul>
                <li>1、獲得您明確同意或基於您主動選擇，我們可能公開披露您的個人資訊；</li>
                <li>2、若我們確定您存在違反法律法規或嚴重違反<b>易迪軟體有限公司</b>相關協議規則的情形，或為保護<b>易迪軟體有限公司</b>及其關聯公司用戶或公眾的人身財產安全免遭侵害，依據法律法規或<b>易迪軟體有限公司</b>相關協議規則並經您同意後，披露關於您的個人資訊，包括相關違規行為及<b>易迪軟體有限公司</b>已對您採取的措施。</li>
            </ul>
            <p>（四）共享、轉讓、公開披露個人資訊時事先徵得授權同意的例外</p>
            <p>下列情形中，共享、轉讓、公開披露您的個人資訊無需事先徵得您的授權同意：</p>
            <ul>
                <li>1、與國家安全、國防安全有關的；</li>
                <li>2、與公共安全、公共衛生、重大公共利益有關的；</li>
                <li>3、與犯罪偵查、起訴、審判及執行判決等有關的；</li>
                <li>4、出於維護您或其他個人生命、財產等重大合法權益但又難以取得本人同意的；</li>
                <li>5、您自行向社會公眾公開的個人資訊；</li>
                <li>6、從合法公開披露的資訊中收集個人資訊的，如合法的新聞報導、政府資訊公開等渠道。</li>
            </ul>
            根據法律規定，對於經過去標識化處理且確保資料接收方無法復原並重新識別個人資訊主體的資訊，不屬於個人資訊的對外共享、轉讓及公開披露行為，對此類資料的保存及處理無需另行通知並徵得您的同意。
            <h3>四、我們如何保護您的個人資訊安全</h3>
            <p>（一）我們已採取符合業界通用解決方案及合理可行的安全防護措施，保護您所提供的個人資訊安全，防止個人資訊遭受未經授權的存取、公開披露、使用、修改、損毀或丟失。例如，您在瀏覽器與伺服器之間交換資料（如信用卡資訊）時，會受 SSL（Secure Socket Layer）協議加密保護；我們亦會使用加密技術提高個人資訊的安全性；同時採用受信賴的保護機制防止個人資訊遭到惡意攻擊；並部署存取控制機制，盡力確保只有經授權的人員可存取個人資訊；此外，我們亦會舉辦安全與隱私保護培訓課程，加強員工對保護個人資訊重要性的認識。</p>
            <p>（二）我們擁有業界先進的以資料為核心、圍繞資料生命週期進行管理的資料安全體系，從組織建構、制度設計、員工管理、產品技術等多維度提升整體系統的安全性。</p>
            <p>（三）我們會採取合理可行的措施，盡力避免收集無關的個人資訊。我們僅在達成本政策所述目的所需的期限內保留您的個人資訊，除非需延長保留期或受到法律允許。</p>
            <p>（四）網際網路並非絕對安全的環境，我們強烈建議您不要使用非<b>易迪軟體有限公司</b>推薦的通訊方式傳送個人資訊。您可透過我們的服務建立聯繫及相互分享。當您透過我們的服務創建交流、交易或分享時，您可自主選擇溝通、交易或分享對象，使其能看到您的交易內容、聯絡方式、交流資訊或分享內容等相關資訊。</p>
            <p>若您發現您的個人資訊，尤其是您的帳號或密碼發生洩露，請立即聯絡<b>易迪軟體有限公司</b>客服，以便我們依據您的申請採取相應措施。</p>
            <p>請注意，您在使用我們服務時自願共享甚至公開分享的資訊，可能涉及您或他人的個人資訊甚至個人敏感資訊；例如您在發表動態或於群組、圈子等公開場合上傳包含個人資訊的圖片，請您謹慎考慮是否共享此類資訊。</p>
            <p>請使用複雜密碼以協助我們保障您的帳號安全，我們將盡力確保您傳送給我們的任何資訊的安全性。</p>
            <p>同時，我們亦會依監管機關要求，上報個人資訊安全事件的處理情形。</p>
            <h3>五、您如何管理您的個人資訊</h3>
            <p>您可透過以下方式存取及管理您的個人資訊：</p>
            <p>（一）存取您的個人資訊</p>
            <p>您有權存取您的個人資訊，但法律法規另有規定的例外除外。您可透過以下方式自行存取您的個人資訊：</p>
            <p>帳戶資訊——若您希望存取或編輯帳戶中的個人證件資訊、手機綁定、支付資訊、更改密碼、添加安全資訊或關閉帳戶，您可登入帳號並透過“更多”-“設定”-“帳號與安全”執行相關操作。</p>
            <p>個人資料——若您希望存取或編輯個人資料中的暱稱、頭像、家鄉、情感狀態、出生年月日、星座、職業、學校、興趣愛好及其他資料，您可登入帳號並透過“更多”-“查看或編輯個人資料”進行操作。</p>
            <p>動態資訊——您可登入帳號並透過“我的動態”存取或清除您發表的動態歷史記錄。</p>
            <p>若您無法透過上述途徑存取該等個人資訊，您可隨時透過<b>易迪軟體有限公司</b>客服與我們聯繫，我們將在30天內回覆您的存取請求。</p>
            <p>對於您在使用我們產品或服務過程中產生的其他個人資訊，我們將依據本條相關規定予以提供。</p>
            <p>（二）更正或補充您的個人資訊</p>
            <p>若您發現我們處理的有關您的個人資訊存在錯誤，您有權要求我們予以更正或補充。您可依據本條“（一）存取您的個人資訊”中所述方式提出更正或補充申請。</p>
            <p>（三）刪除您的個人資訊</p>
            <p>您可依據本條“（一）存取您的個人資訊”中所述方式，刪除部分個人資訊。</p>
            <p>在下列情形中，您可向我們提出刪除個人資訊的請求：</p>
            <ul>
                <li>1、若我們處理個人資訊的行為違反法律法規；</li>
                <li>2、若我們在未徵得您明確同意的情況下收集或使用您的個人資訊；</li>
                <li>3、若我們處理個人資訊的行為嚴重違反與您的約定；</li>
                <li>4、若您不再使用我們的產品或服務，或您主動註銷了帳號；</li>
                <li>5、若我們永久不再向您提供產品或服務。</li>
            </ul>
            <p>若我們決定響應您的刪除請求，我們將盡可能通知從我們處獲取您個人資訊的相關方，要求其及時刪除，但除非法律法規另有規定或該等主體已獲得您的獨立授權，否則可能無法完全通知。</p>
            <p>當您從我們的服務中刪除資訊後，我們可能不會立即從備份系統中刪除相應資訊，但會在備份更新時予以刪除。</p>
            <p>（四）響應您的請求</p>
            <p>為保障安全，您可能需要提供書面請求或以其他方式證明您的身份，我們可能會要求您先驗證身份後，再處理您的請求。</p>
            <p>我們將在 30 天內做出回應。如您不滿意，亦可透過<b>易迪軟體有限公司</b>客服提出申訴。</p>
            <p>對於合理請求，我們原則上不會收取費用；但對於多次重複、超出合理範圍的請求，我們將視情況收取一定成本費用；對於無端重複、需要過多技術手段（例如需開發新系統或從根本上改變現行慣例）、可能對他人合法權益造成風險或極不切實際的請求，我們可能會予以拒絕。</p>
            <p>在下列情形中，依據法律法規要求，我們將無法回應您的請求：</p>
            <ul>
                <li>1、與國家安全、國防安全有關的；</li>
                <li>2、與公共安全、公共衛生、重大公共利益有關的；</li>
                <li>3、與犯罪偵查、起訴、審判及執行判決等有關的；</li>
                <li>4、有充分證據顯示個人資訊主體存在主觀惡意或濫用權利的；</li>
                <li>5、回應您的請求將導致您或其他個人、組織的合法權益受到嚴重損害；</li>
                <li>6、涉及商業秘密的。</li>
            </ul>
            <h3>六、我們如何處理未成年人的個人資訊</h3>
            <p>若未經父母或監護人同意，未成年人不得創建其用戶帳號。若您為未成年人，建議請父母或監護人仔細閱讀本隱私權政策，並在徵得其同意後使用我們的服務或向我們提供資訊。</p>
            <p>對於經父母或監護人同意使用我們產品或服務而收集的未成年人個人資訊，我們僅在法律法規允許、父母或監護人明確同意或為保護未成年人所必需的情況下使用、共享、轉讓或披露該資訊。</p>
            <h3>七、您的個人資訊如何在全球範圍轉移</h3>
            <p>我們在台灣境內運營中收集及產生的個人資訊，除下列情形外均存放於台灣境內：</p>
            <ul>
                <li>1、法律法規有明確規定；</li>
                <li>2、獲得您的明確授權；</li>
                <li>3、您透過網際網路進行跨境直播／發表動態等個人主動行為。</li>
            </ul>
            <p>針對上述情形，我們將確保依據本隱私權政策對您的個人資訊提供足夠保護。</p>
            <h3>八、我們集成的第三方 SDK</h3>
            <ul>
                <li>1、我們的產品基於 flutter 開發，應用運行期間可能會收集您的設備唯一識別碼（如 IMEI／Android ID／DEVICE_ID／IDFA、SIM 卡 IMSI 等資訊）以提供統計分析服務，並透過應用啟動數據及異常錯誤日誌分析以改進性能和用戶體驗，從而為用戶提供更好的服務。</li>
                <li>2、flutter 基礎模組預設集成相關 SDK 用於頁面渲染及性能優化，應用運行期間可能會讀取及寫入外部儲存器，並通過啟動數據及異常錯誤日誌分析改進性能與用戶體驗。</li>
                <li>3、消息推送服務供應商：由每日互動股份有限公司提供推送技術服務，我們可能會將您的設備平台、設備廠商、設備品牌、設備識別碼、應用列表資訊、網路資訊以及位置相關資訊提供給每日互動股份有限公司，以用於向您提供消息推送技術服務。</li>
            </ul>
            <p>在向您推送消息時，我們可能授權每日互動股份有限公司進行鏈路調節，以確保您能及時接收到我們推送的消息。詳細內容請參閱《個推用戶隱私政策》。</p>
            <h3>九、本隱私權政策如何更新</h3>
            <p>我們的隱私權政策可能會變更。</p>
            <p>除非得到您明確同意，我們不會限制您根據本隱私權政策所應享有的權利。對於重大變更，我們會提供顯著通知（包括透過易迪軟體有限公司公告或向您提供彈窗提示）。</p>
            <p>本政策所指的重大變更包括但不限於：</p>
            <ul>
                <li>1、我們的服務模式發生重大變化（例如處理個人資訊的目的、類型或使用方式）；</li>
                <li>2、我們在控制權等方面發生重大變化（例如並購重組等導致所有權變更）；</li>
                <li>3、個人資訊共享、轉讓或公開披露的主要對象發生變化；</li>
                <li>4、您參與個人資訊處理方面的權利及其行使方式發生重大變化；</li>
                <li>5、我們負責處理個人資訊安全的責任部門、聯絡方式及申訴渠道發生變化；</li>
                <li>6、個人資訊安全影響評估報告顯示存在高風險時。</li>
            </ul>
            <p>我們還將將本隱私權政策的舊版本存檔以供查閱。</p>
            <h3>十、如何聯絡我們</h3>
            <p>您可透過以下方式與我們聯絡，我們將在 30 天內回覆您的請求：</p>
            <ul>
                <li>1、若對本政策內容有任何疑問、意見或建議，您可透過易迪軟體有限公司線上客服與我們聯繫；</li>
                <li>2、若發現個人資訊可能遭洩露，您可發送電子郵件至 info@lmgoal.com 進行投訴舉報；</li>
                <li>3、我們亦設有個人資訊保護專責部門，您可直接與其聯繫。</li>
            </ul>
            <p>若您對我們的回覆不滿意，尤其認為我們的個人資訊處理行為損害了您的合法權益，您仍可向被告所在地有管轄權的法院提起訴訟以尋求解決。</p>
            <h2><b>易迪軟體有限公司</b></h2>
            <p>更新日期：2025/03/04</p>
        </article>
    );
};

export default PrivacyPolicy;